const mapStateToProps = (state) => {
    const {
        api:{
            directoryList,
            directoryData,
        }={},
        user:{
            rights,
        }={},

        service:{
            Api:{
                getDirectoryData,
            }={}
        }={},

        ui: {
            burgerMenuOpened
        } = {},

    } = state;
    return {
        directoryList,
        directoryData,
        rights,
        getDirectoryData,
        burgerMenuOpened
    }
}

export default mapStateToProps;